import { preloadList } from "./assets/preload-list";

for (const node of preloadList) {
	const link = document.createElement("link");
	link.rel = "preload";
	link.href = node.url;
	link.as = node.type;
	document.head.appendChild(link);
}
